/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Loader } from '@mantine/core';
import { Outlet } from 'react-router-dom';

import { useEndpointEnableLogging } from '@fai/friendli-suite/features/products/dedicated-endpoints/endpoints/use-endpoint-enable-logging';
import { customJson } from '@fai/third-party/react-router-dom';

export default function UsageValidationWrapper() {
  const { enableContentLogging, loading } = useEndpointEnableLogging();

  if (loading) return <Loader />;

  if (!enableContentLogging) {
    throw customJson({ message: 'This page is inaccessible.' }, { status: 403 });
  }

  return <Outlet />;
}
